// extracted by mini-css-extract-plugin
export default {"container":"MyListing_container__scl4S","largeText":"MyListing_largeText__b+-Tk"};